import { webApi } from '@mi-front/api-clients';
import { useTheme } from '@mui/material';
import { memo } from 'react';
import { useFragmentGridContext } from '../../fragments-grid/FragmentGridContext';
import { DeterministicWaveform } from './AudioFragmentCardWaveform';

/** Matches SegmentsWaveform default foreground color in dark mode. */
const LOGGER_WAVEFORM_DARK_COLOR = 'rgba(28,192,252,0.65)';

/** Number of waveform bars per breakpoint (sm and up). */
const BARS_BY_BREAKPOINT = {
  xl: 120,
  lg: 90,
  md: 80,
  sm: 80,
} as const;

/**
 * Derives the number of waveform bars from breakpointsUp (same logic as previous useWaveformBars).
 */
function getBarsFromBreakpoints(breakpointsUp: {
  isMd: boolean;
  isLg: boolean;
  isXl: boolean;
}): number {
  if (breakpointsUp.isXl) return BARS_BY_BREAKPOINT.xl;
  if (breakpointsUp.isLg) return BARS_BY_BREAKPOINT.lg;
  if (breakpointsUp.isMd) return BARS_BY_BREAKPOINT.md;
  return BARS_BY_BREAKPOINT.sm;
}

/**
 * Renders deterministic waveform for an audio fragment. Uses FragmentGridContext for breakpoints.
 */
export const AudioFragmentWaveform = memo(function AudioFragmentWaveform({
  fragment,
}: {
  fragment: webApi.FragmentListItemDto;
}) {
  const { breakpointsUp } = useFragmentGridContext();
  const { palette } = useTheme();
  const bars = getBarsFromBreakpoints(breakpointsUp);
  const color = palette.mode === 'dark' ? LOGGER_WAVEFORM_DARK_COLOR : undefined;

  return <DeterministicWaveform seed={fragment.id} bars={bars} height={80} color={color} />;
});
